/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateSalesforceCase
// ====================================================

export interface CreateSalesforceCase_case {
  status: SalesforceCaseStatus;
}

export interface CreateSalesforceCase {
  case: CreateSalesforceCase_case;
}

export interface CreateSalesforceCaseVariables {
  input: CreateSalesforceCaseInput;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: orderByOrderNumberAndPostalCode
// ====================================================

export interface orderByOrderNumberAndPostalCode_order_orderItems_product_titles_translations {
  id: string;
  language: string | null;
  value: string | null;
}

export interface orderByOrderNumberAndPostalCode_order_orderItems_product_titles {
  id: string;
  translations:
    | orderByOrderNumberAndPostalCode_order_orderItems_product_titles_translations[]
    | null;
}

export interface orderByOrderNumberAndPostalCode_order_orderItems_product {
  id: string;
  sourceName: string | null;
  titles: orderByOrderNumberAndPostalCode_order_orderItems_product_titles[];
}

export interface orderByOrderNumberAndPostalCode_order_orderItems_supplierOrder {
  id: string;
  status: string;
  trackingCode: string | null;
}

export interface orderByOrderNumberAndPostalCode_order_orderItems {
  id: string;
  quantity: number;
  status: string;
  trackingNumber: string | null;
  supplier: Supplier | null;
  ean: string | null;
  createdAt: any;
  product: orderByOrderNumberAndPostalCode_order_orderItems_product | null;
  supplierOrder: orderByOrderNumberAndPostalCode_order_orderItems_supplierOrder | null;
}

export interface orderByOrderNumberAndPostalCode_order {
  id: string;
  number: string;
  customerFullname: string;
  shipmentPrice: number;
  createdAt: any;
  orderItems: orderByOrderNumberAndPostalCode_order_orderItems[];
}

export interface orderByOrderNumberAndPostalCode {
  order: orderByOrderNumberAndPostalCode_order | null;
}

export interface orderByOrderNumberAndPostalCodeVariables {
  orderNumber: string;
  postalCode: string;
  languageCode?: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: validateOrderNumber
// ====================================================

export interface validateOrderNumber {
  valid: boolean;
}

export interface validateOrderNumberVariables {
  orderNumber: string;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: shipmentsByIds
// ====================================================

export interface shipmentsByIds_shipments_originCountry {
  name: string | null;
  companyName: string | null;
  companyUrl: string | null;
}

export interface shipmentsByIds_shipments_destinationCountry {
  name: string | null;
  companyName: string | null;
  companyUrl: string | null;
}

export interface shipmentsByIds_shipments_events {
  status: ShipmentStatus | null;
  description: string | null;
  createdAt: any | null;
}

export interface shipmentsByIds_shipments {
  id: string | null;
  status: ShipmentStatus | null;
  statusDescription: string | null;
  shippingTime: number | null;
  originCountry: shipmentsByIds_shipments_originCountry | null;
  destinationCountry: shipmentsByIds_shipments_destinationCountry | null;
  events: shipmentsByIds_shipments_events[];
}

export interface shipmentsByIds {
  shipments: shipmentsByIds_shipments[];
}

export interface shipmentsByIdsVariables {
  ids: string[];
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductTitleTranslationFragment
// ====================================================

export interface ProductTitleTranslationFragment {
  id: string;
  language: string | null;
  value: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductTitleFragment
// ====================================================

export interface ProductTitleFragment_translations {
  id: string;
  language: string | null;
  value: string | null;
}

export interface ProductTitleFragment {
  id: string;
  translations: ProductTitleFragment_translations[] | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ProductFragment
// ====================================================

export interface ProductFragment_titles_translations {
  id: string;
  language: string | null;
  value: string | null;
}

export interface ProductFragment_titles {
  id: string;
  translations: ProductFragment_titles_translations[] | null;
}

export interface ProductFragment {
  id: string;
  sourceName: string | null;
  titles: ProductFragment_titles[];
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: SupplierOrderFragment
// ====================================================

export interface SupplierOrderFragment {
  id: string;
  status: string;
  trackingCode: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OrderItemFragment
// ====================================================

export interface OrderItemFragment_product_titles_translations {
  id: string;
  language: string | null;
  value: string | null;
}

export interface OrderItemFragment_product_titles {
  id: string;
  translations: OrderItemFragment_product_titles_translations[] | null;
}

export interface OrderItemFragment_product {
  id: string;
  sourceName: string | null;
  titles: OrderItemFragment_product_titles[];
}

export interface OrderItemFragment_supplierOrder {
  id: string;
  status: string;
  trackingCode: string | null;
}

export interface OrderItemFragment {
  id: string;
  quantity: number;
  status: string;
  trackingNumber: string | null;
  supplier: Supplier | null;
  ean: string | null;
  createdAt: any;
  product: OrderItemFragment_product | null;
  supplierOrder: OrderItemFragment_supplierOrder | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ShipmentEventFragment
// ====================================================

export interface ShipmentEventFragment {
  status: ShipmentStatus | null;
  description: string | null;
  createdAt: any | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ShipmentCountryFragment
// ====================================================

export interface ShipmentCountryFragment {
  name: string | null;
  companyName: string | null;
  companyUrl: string | null;
}

/* tslint:disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum SalesforceCaseStatus {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS"
}

export enum Supplier {
  ALIEXPRESS = "ALIEXPRESS",
  BANGGOOD = "BANGGOOD",
  JS_WEBSHOPS = "JS_WEBSHOPS",
  UNKNOWN = "UNKNOWN"
}

export enum ShipmentStatus {
  ARRIVED_DESTINATION_COUNTRY = "ARRIVED_DESTINATION_COUNTRY",
  ARRIVED_DESTINATION_COUNTRY_ERROR = "ARRIVED_DESTINATION_COUNTRY_ERROR",
  DELIVERED = "DELIVERED",
  DEPARTED_ORIGIN_COUNTRY = "DEPARTED_ORIGIN_COUNTRY",
  DEPARTED_ORIGIN_COUNTRY_ERROR = "DEPARTED_ORIGIN_COUNTRY_ERROR",
  INTERMEDIATE = "INTERMEDIATE",
  IN_TRANSIT = "IN_TRANSIT",
  NOT_FOUND = "NOT_FOUND",
  PICKED_UP_BY_CARRIER = "PICKED_UP_BY_CARRIER",
  RETURNED_TO_SENDER = "RETURNED_TO_SENDER",
  SHIPPING_DEADLINE_EXPIRED = "SHIPPING_DEADLINE_EXPIRED",
  UNKNOWN = "UNKNOWN",
  UNSUCCESSFUL_DELIVERY = "UNSUCCESSFUL_DELIVERY"
}

/**
 *
 */
export interface CreateSalesforceCaseInput {
  description?: string | null;
  email?: string | null;
  name?: string | null;
  orderNumber?: string | null;
  phone?: string | null;
  reason?: string | null;
  subject?: string | null;
  webshop?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================



// WEBPACK FOOTER //
// ./src/graphql/types.ts